export default "__VITE_ASSET__366484b0__"